import { Route } from 'react-router';
import {
  PromoDetailsPage,
  PromosPage,
  PublicPromosPage,
} from '@betty/promos/pages';
import DynamicRoute from './DynamicRoute';

export const renderPromosRoutes = () => (
  <Route path="promos">
    <Route
      index
      element={
        <DynamicRoute
          AnonymousComponent={PublicPromosPage}
          AuthenticatedComponent={PromosPage}
        />
      }
    />
    <Route path=":id" element={<PromoDetailsPage />} />
  </Route>
);
